import { ProductSearchPage } from './ProductSearchPage';
export default ProductSearchPage;
